(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      // Inicializar menú personalizado
      this.initCustomMegaMenu();
    }

    initCustomMegaMenu() {
      const megaMenus = document.querySelectorAll('.mega-menu');
      if (!megaMenus.length) return;

      // Lazy load imágenes cuando se abre el mega menú
      megaMenus.forEach((menu) => {
        menu.addEventListener('toggle', (event) => {
          if (menu.hasAttribute('open')) {
            // Cargar imágenes cuando se abre el menú
            const lazyImages = menu.querySelectorAll('img[loading="lazy"]');
            if (lazyImages.length) {
              lazyImages.forEach((img) => {
                // Pre-cargar la imagen para evitar saltos visuales
                const imgSrc = img.getAttribute('src');
                if (imgSrc) {
                  const imgLoader = new Image();
                  imgLoader.src = imgSrc;
                }
              });
            }

            // Añadir clase para animar la entrada de contenido
            setTimeout(() => {
              const content = menu.querySelector('.mega-menu__content');
              if (content) content.classList.add('animated');
            }, 10);
          }
        });
      });

      // Optimización de interacción
      document.querySelectorAll('.header__menu-item').forEach((item) => {
        // Usar evento mouseenter para pre-cargar mega menu
        item.addEventListener('mouseenter', () => {
          const menuId = item.getAttribute('id');
          if (!menuId) return;

          const details = item.closest('details');
          if (details && !details.hasAttribute('open')) {
            // Pre-cargar contenido sin abrir el menú
            const content = details.querySelector('.mega-menu__content');
            if (content) {
              // Trigger prefetch del contenido
              requestIdleCallback(() => {
                const allLinks = content.querySelectorAll('a');
                if (allLinks.length > 0) {
                  // Prefetch del primer enlace para mejorar la velocidad de navegación
                  const firstLink = allLinks[0].getAttribute('href');
                  if (firstLink) {
                    const linkPrefetch = document.createElement('link');
                    linkPrefetch.rel = 'prefetch';
                    linkPrefetch.href = firstLink;
                    linkPrefetch.as = 'document';
                    document.head.appendChild(linkPrefetch);
                  }
                }
              });
            }
          }
        });
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Polyfill para requestIdleCallback
  window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
      const start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start));
          },
        });
      }, 1);
    };

  } catch(e) { console.error(e); }
})();
})();
